import * as React from 'react'

import { ExternalSchoolFields as IExternalSchool } from 'main/gql/externalSchool'
import { User_user } from 'main/gql/user'
import { Link, ScreenClass, ScreenClassRender, SmartImage, Text } from 'main/ui'

import { Step } from '../../types'
import JoinForm from './JoinForm'

import {
  Container,
  JoinFormContainer,
  LinkContainer,
  RemoveCtaContainer,
  ValuePropositionContainer,
} from './Join.styles'

const MOBILE_IMAGE_UUID = '092b38d0-9bf7-4285-8c34-aa7966f42875'
const DESKTOP_IMAGE_UUID = '0ff00833-6d6c-403d-bff4-26272acfe35e'

const imageUuids = {
  lg: DESKTOP_IMAGE_UUID,
  md: DESKTOP_IMAGE_UUID,
  sm: MOBILE_IMAGE_UUID,
  xl: DESKTOP_IMAGE_UUID,
  xs: MOBILE_IMAGE_UUID,
}

interface IProps {
  externalSchool: IExternalSchool
  user: User_user | null
  onClickRemove: () => void
  onChangeStep: React.Dispatch<React.SetStateAction<Step>>
}

export default function Join(props: IProps) {
  const { externalSchool, user, onChangeStep, onClickRemove } = props

  return (
    <Container>
      <ScreenClassRender render={renderValueProposition} />
      <JoinFormContainer>
        <JoinForm user={user} externalSchool={externalSchool} onChangeStep={onChangeStep} />
        <RemoveCtaContainer>
          <Text>
            <Link to="#" onClick={onClickRemove}>
              Click here
            </Link>{' '}
            if you would like to be removed from this site.
          </Text>
        </RemoveCtaContainer>
      </JoinFormContainer>
    </Container>
  )
}

function renderValueProposition(screenClass: ScreenClass) {
  return (
    <ValuePropositionContainer>
      <SmartImage critical uuid={imageUuids[screenClass]} />
      <LinkContainer>
        <Link to="/start" target="_blank">
          Learn about all the benefits of joining Wonderschool
        </Link>
      </LinkContainer>
    </ValuePropositionContainer>
  )
}
